/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsListQueryParams = zod.object({
  "car_id": zod.string().uuid().optional().describe('Filter tickets by a single car ID'),
  "cars": zod.array(zod.string().uuid()).optional().describe('Filter tickets by one or more car IDs (repeat the param)'),
  "entry_type": zod.array(zod.enum(['deferred', 'emergency', 'inspection', 'modernization', 'regular', 'repair', 'visit'])).optional().describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "invoice_id": zod.string().uuid().optional().describe('Filter tickets to a single invoice.'),
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "number": zod.string().optional(),
  "offset": zod.number().optional().describe('The initial index from which to return the results.'),
  "ordering": zod.string().optional().describe('Comma-separated ordering fields; prefix with `-` for descending.'),
  "portfolio": zod.array(zod.string().uuid()).optional(),
  "portfolio_name": zod.string().optional(),
  "property": zod.string().uuid().optional(),
  "property_name": zod.string().optional(),
  "query": zod.string().optional(),
  "region": zod.array(zod.string().nullable()).optional(),
  "search": zod.string().optional(),
  "service_provider": zod.array(zod.string().uuid()).optional(),
  "started_time_after": zod.string().datetime({"offset":true}).optional(),
  "started_time_before": zod.string().datetime({"offset":true}).optional()
})

export const ticketsListResponseResultsItemNumberMax = 20;

export const ticketsListResponseResultsItemInvoiceOneNumberMax = 100;

export const ticketsListResponseResultsItemAttachmentsItemPageNumberMin = 0;
export const ticketsListResponseResultsItemAttachmentsItemPageNumberMax = 2147483647;



export const TicketsListResponse = zod.object({
  "count": zod.number(),
  "next": zod.string().url().nullish(),
  "previous": zod.string().url().nullish(),
  "metadata": zod.object({
  "numTickets": zod.number().optional(),
  "timeOnSiteSeconds": zod.number().optional(),
  "maintenanceSeconds": zod.number().optional(),
  "regular": zod.number().optional(),
  "emergency": zod.number().optional(),
  "deferred": zod.number().optional()
}).strict(),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsListResponseResultsItemNumberMax),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()).optional(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsListResponseResultsItemInvoiceOneNumberMax)
}).strict().nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}),
  "finishedTime": zod.string().datetime({"offset":true}),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsListResponseResultsItemAttachmentsItemPageNumberMin).max(ticketsListResponseResultsItemAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().nullish(),
  "startedTimeHolidayName": zod.string().nullable().describe('Name of the public holiday if started_time falls on one, else null.')
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsCreateBodyNumberMax = 20;



export const ticketsCreateBodyInvoiceOneNumberMax = 100;





export const TicketsCreateBody = zod.object({
  "number": zod.string().min(1).max(ticketsCreateBodyNumberMax),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "name": zod.string().min(1)
})).optional(),
  "property": zod.object({
  "name": zod.string().min(1),
  "timeZone": zod.string().optional()
}).nullable(),
  "invoice": zod.object({
  "number": zod.string().min(1).max(ticketsCreateBodyInvoiceOneNumberMax)
}).nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().min(1).optional(),
  "id": zod.string().uuid().optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}),
  "finishedTime": zod.string().datetime({"offset":true}),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().min(1).nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const ticketsCreateResponseNumberMax = 20;

export const ticketsCreateResponseInvoiceOneNumberMax = 100;

export const ticketsCreateResponseAttachmentsItemPageNumberMin = 0;
export const ticketsCreateResponseAttachmentsItemPageNumberMax = 2147483647;



export const TicketsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsCreateResponseNumberMax),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()).optional(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsCreateResponseInvoiceOneNumberMax)
}).strict().nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}),
  "finishedTime": zod.string().datetime({"offset":true}),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsCreateResponseAttachmentsItemPageNumberMin).max(ticketsCreateResponseAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().nullish(),
  "startedTimeHolidayName": zod.string().nullable().describe('Name of the public holiday if started_time falls on one, else null.')
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this ticket.')
})

export const ticketsRetrieveResponseNumberMax = 20;

export const ticketsRetrieveResponseInvoiceOneNumberMax = 100;

export const ticketsRetrieveResponseAttachmentsItemPageNumberMin = 0;
export const ticketsRetrieveResponseAttachmentsItemPageNumberMax = 2147483647;



export const TicketsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsRetrieveResponseNumberMax),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()).optional(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsRetrieveResponseInvoiceOneNumberMax)
}).strict().nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}),
  "finishedTime": zod.string().datetime({"offset":true}),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsRetrieveResponseAttachmentsItemPageNumberMin).max(ticketsRetrieveResponseAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().nullish(),
  "startedTimeHolidayName": zod.string().nullable().describe('Name of the public holiday if started_time falls on one, else null.')
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this ticket.')
})

export const ticketsUpdateBodyNumberMax = 20;



export const ticketsUpdateBodyInvoiceOneNumberMax = 100;





export const TicketsUpdateBody = zod.object({
  "number": zod.string().min(1).max(ticketsUpdateBodyNumberMax),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "name": zod.string().min(1)
})).optional(),
  "property": zod.object({
  "name": zod.string().min(1),
  "timeZone": zod.string().optional()
}).nullable(),
  "invoice": zod.object({
  "number": zod.string().min(1).max(ticketsUpdateBodyInvoiceOneNumberMax)
}).nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().min(1).optional(),
  "id": zod.string().uuid().optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}),
  "finishedTime": zod.string().datetime({"offset":true}),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().min(1).nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const ticketsUpdateResponseNumberMax = 20;

export const ticketsUpdateResponseInvoiceOneNumberMax = 100;

export const ticketsUpdateResponseAttachmentsItemPageNumberMin = 0;
export const ticketsUpdateResponseAttachmentsItemPageNumberMax = 2147483647;



export const TicketsUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsUpdateResponseNumberMax),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()).optional(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsUpdateResponseInvoiceOneNumberMax)
}).strict().nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}),
  "finishedTime": zod.string().datetime({"offset":true}),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsUpdateResponseAttachmentsItemPageNumberMin).max(ticketsUpdateResponseAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().nullish(),
  "startedTimeHolidayName": zod.string().nullable().describe('Name of the public holiday if started_time falls on one, else null.')
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this ticket.')
})

export const ticketsPartialUpdateBodyNumberMax = 20;



export const ticketsPartialUpdateBodyInvoiceOneNumberMax = 100;





export const TicketsPartialUpdateBody = zod.object({
  "number": zod.string().min(1).max(ticketsPartialUpdateBodyNumberMax).optional(),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).optional().describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "name": zod.string().min(1)
})).optional(),
  "property": zod.object({
  "name": zod.string().min(1),
  "timeZone": zod.string().optional()
}).nullish(),
  "invoice": zod.object({
  "number": zod.string().min(1).max(ticketsPartialUpdateBodyInvoiceOneNumberMax)
}).nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().min(1).optional(),
  "id": zod.string().uuid().optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}).optional(),
  "finishedTime": zod.string().datetime({"offset":true}).optional(),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().min(1).nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const ticketsPartialUpdateResponseNumberMax = 20;

export const ticketsPartialUpdateResponseInvoiceOneNumberMax = 100;

export const ticketsPartialUpdateResponseAttachmentsItemPageNumberMin = 0;
export const ticketsPartialUpdateResponseAttachmentsItemPageNumberMax = 2147483647;



export const TicketsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsPartialUpdateResponseNumberMax),
  "entryType": zod.enum(['regular', 'emergency', 'deferred', 'visit', 'modernization', 'inspection', 'repair']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback\n\* `visit` - Maintenance Visit\n\* `modernization` - Modernization\n\* `inspection` - Inspection\n\* `repair` - Repair'),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()).optional(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(ticketsPartialUpdateResponseInvoiceOneNumberMax)
}).strict().nullish(),
  "serviceProviderGroup": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullish(),
  "callTime": zod.string().datetime({"offset":true}).nullish(),
  "startedTime": zod.string().datetime({"offset":true}),
  "finishedTime": zod.string().datetime({"offset":true}),
  "timeOnSiteRegularHours": zod.string().nullish(),
  "travelTimeRegularHours": zod.string().nullish(),
  "timeOnSiteOvertime": zod.string().nullish(),
  "travelTimeOvertime": zod.string().nullish(),
  "notes": zod.string().optional(),
  "problemDescription": zod.string().optional(),
  "workPerformed": zod.string().optional(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsPartialUpdateResponseAttachmentsItemPageNumberMin).max(ticketsPartialUpdateResponseAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "autoUpload": zod.boolean().optional(),
  "equipmentFailure": zod.boolean().nullish(),
  "problemType": zod.string().nullish(),
  "startedTimeHolidayName": zod.string().nullable().describe('Name of the public holiday if started_time falls on one, else null.')
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this ticket.')
})

export const TicketsDestroyResponse = zod.void()

export const TicketsAttachmentsListParams = zod.object({
  "ticketPk": zod.string().uuid()
})

export const ticketsAttachmentsListResponsePageNumberMin = 0;
export const ticketsAttachmentsListResponsePageNumberMax = 2147483647;



export const TicketsAttachmentsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "ticket": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsAttachmentsListResponsePageNumberMin).max(ticketsAttachmentsListResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')
export const TicketsAttachmentsListResponse = zod.array(TicketsAttachmentsListResponseItem)

export const TicketsAttachmentsCreateParams = zod.object({
  "ticketPk": zod.string().uuid()
})

export const ticketsAttachmentsCreateBodyPageNumberMin = 0;
export const ticketsAttachmentsCreateBodyPageNumberMax = 2147483647;



export const TicketsAttachmentsCreateBody = zod.object({
  "ticket": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsAttachmentsCreateBodyPageNumberMin).max(ticketsAttachmentsCreateBodyPageNumberMax).nullish()
}).describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const ticketsAttachmentsCreateResponsePageNumberMin = 0;
export const ticketsAttachmentsCreateResponsePageNumberMax = 2147483647;



export const TicketsAttachmentsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "ticket": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsAttachmentsCreateResponsePageNumberMin).max(ticketsAttachmentsCreateResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const TicketsAttachmentsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this ticket attachment.'),
  "ticketPk": zod.string().uuid()
})

export const ticketsAttachmentsRetrieveResponsePageNumberMin = 0;
export const ticketsAttachmentsRetrieveResponsePageNumberMax = 2147483647;



export const TicketsAttachmentsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "ticket": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(ticketsAttachmentsRetrieveResponsePageNumberMin).max(ticketsAttachmentsRetrieveResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const TicketsAttachmentsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this ticket attachment.'),
  "ticketPk": zod.string().uuid()
})

export const TicketsAttachmentsDestroyResponse = zod.void()

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsAggregateRetrieveQueryParams = zod.object({
  "date_after": zod.string().date().optional().describe('Explicit start of the date range (inclusive).'),
  "date_before": zod.string().date().optional().describe('Explicit end of the date range (inclusive).'),
  "group_by": zod.string().optional().describe('Optional whitelisted group-by dimension (entity-specific, e.g. ``property``, ``portfolio``, ``entry_type``). Omit for a single scalar value; an unknown value returns 400 listing the valid dimensions.'),
  "limit": zod.number().optional().describe('Top-N rows for a grouped result, clamped to [1, 50]. Ignored for scalar results.'),
  "metric": zod.string().describe('Whitelisted metric to compute (entity-specific, e.g. ``invoice_amount``, ``ticket_count``, ``unit_count``). An unknown value returns 400 listing the entity\'s valid metrics.'),
  "period": zod.string().optional().describe('Named relative date range (one of ``30d``\/``90d``\/``ytd``\/``ttm``\/``all``\/``custom``) resolved into the entity\'s date filter. ``all`` applies no date bound at all. Routed to ``dropped_filters`` for entities without a date filter.')
})

export const TicketsAggregateRetrieveResponse = zod.union([zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "value": zod.number().nullable(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Ungrouped aggregate: a single scalar ``value`` for the whole scope.'),zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "groupBy": zod.string(),
  "rows": zod.array(zod.object({
  "group": zod.string().nullable(),
  "value": zod.number().nullable()
}).strict().describe('One row of a grouped aggregate: a display label and its metric value.')),
  "total": zod.number().nullable(),
  "groupCount": zod.number(),
  "shown": zod.number(),
  "truncated": zod.boolean(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Grouped aggregate: top-N rows plus the grand total and group count.')])

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsDetermineEntryTypeCreateBody = zod.object({
  "tickets": zod.array(zod.object({
  "problemDescription": zod.string(),
  "isEmergency": zod.string()
}))
})

export const TicketsDetermineEntryTypeCreateResponse = zod.object({
  "results": zod.array(zod.object({
  "entryType": zod.string()
}).strict())
}).strict()

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const TicketsDetermineProblemTypeCreateBody = zod.object({
  "tickets": zod.array(zod.object({
  "workPerformed": zod.string(),
  "problemDescription": zod.string()
}))
})

export const TicketsDetermineProblemTypeCreateResponse = zod.object({
  "results": zod.array(zod.object({
  "problemType": zod.string(),
  "equipmentRelated": zod.string()
}).strict())
}).strict()

/**
 * List the selectable ticket problem types (the dropdown options the
 * ticket form populates). Replaces reading the choices off an OPTIONS
 * request, which the generated SDK couldn't represent (AMP-502).
 */
export const TicketsProblemTypesListResponseItem = zod.object({
  "name": zod.string()
}).strict().describe('One selectable problem type. ``name`` is the stable slug callers submit\non a ticket\'s ``problemType`` field.')
export const TicketsProblemTypesListResponse = zod.array(TicketsProblemTypesListResponseItem)

